export const ASSIGNMENTS_API_URL = 'assignments';

export const ASSIGNMENTS_CONTEXT_ERROR_MESSAGE =
  'AssignmentsContext must be used inside AssignmentsContext Provider scope';

export const USE_ASSIGNMENTS_QUERY_KEY = 'assignments';
